import { render, staticRenderFns } from "./CertificateRequestList.vue?vue&type=template&id=2724b29c&scoped=true"
import script from "./CertificateRequestList.vue?vue&type=script&lang=js"
export * from "./CertificateRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2724b29c",
  null
  
)

export default component.exports